module.exports = __webpack_public_path__ + "static/media/imgNoticiaBig2.d4b45325.jpg";